import { jsxs as e, jsx as o } from "react/jsx-runtime";
const n = ({ className: t }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: t,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M25 4.16669V6.66669C25 9.02371 25 10.2022 25.7322 10.9345C26.4645 11.6667 27.643 11.6667 30 11.6667L32.5 11.6667",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6.66669 26.6666L6.66669 13.3333C6.66669 8.61927 6.66669 6.26225 8.13115 4.79778C9.59562 3.33331 11.9526 3.33331 16.6667 3.33331L23.6193 3.33331C24.3006 3.33331 24.6412 3.33331 24.9475 3.46018C25.2538 3.58705 25.4946 3.82791 25.9763 4.30962L32.357 10.6903C32.8388 11.1721 33.0796 11.4129 33.2065 11.7192C33.3334 12.0255 33.3334 12.3661 33.3334 13.0474L33.3334 26.6666C33.3334 31.3807 33.3334 33.7377 31.8689 35.2022C30.4044 36.6666 28.0474 36.6666 23.3334 36.6666L16.6667 36.6666C11.9526 36.6666 9.59562 36.6666 8.13115 35.2022C6.66669 33.7377 6.66669 31.3807 6.66669 26.6666Z",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M13.3333 18.3333L26.6666 18.3333M13.3333 23.3333L26.6666 23.3333M13.3333 28.3333H20.2847",
          stroke: "#A8A29E",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  n as FilesEmptyIcon
};
